import ApiService from "./api";

const Attribute = {
    show(code, params) {
        return ApiService.get('attribute/'+code, {params: params});
    },
    options(code, params) {
        return ApiService.get('attribute/'+code+'/options', {params: params});
    },
    option(code, option, params) {
        return ApiService.get("attribute/"+code+"/option/"+option, {params: params});
    },
};

export default Attribute;